<nav class="align-items-end desktop" [attr.aria-label]="'navigation.aria.desktop_navigation' | translate">
  <ul class="ps-0">
    @for (route of getRoutes(); track $index) {
      @if (isMenuItemDisplayed(route)) {
        <ng-container>
          <!-- No child -->
          @if (!route.children || (route.children && route.children.length === 0)) {
            <li class="me-3">
              <a [routerLink]="route.path" routerLinkActive="active" class="nav-link">
                {{ route.data?.title | translate }}
              </a>
            </li>
          }

          <!-- Has children -->
          @if (route.children && route.children.length > 0) {
            <li
              class="me-3"
              [matMenuTriggerFor]="menu"
              #trigger="matMenuTrigger"
              role="button"
              tabindex="0"
              aria-haspopup="true"
              [attr.aria-expanded]="trigger.menuOpen"
              [class.active]="isChildRouteActive(route)"
              (keydown.enter)="trigger.openMenu()"
              (keydown.space)="trigger.openMenu(); $event.preventDefault()"
            >
              {{ route.data?.title | translate }}
            </li>

            <mat-menu
              class="py-3 px-2"
              #menu="matMenu"
              direction="down"
              yPosition="below"
              [hasBackdrop]="false"
              role="menu"
              [attr.aria-label]="'navigation.aria.menu_navigation' | translate"
            >
              @for (child of route.children; track $index) {
                @if (isMenuItemDisplayed(child) && child.data?.title) {
                  <button mat-menu-item [routerLink]="route.path + '/' + child.path">
                    {{ child.data?.title | translate }}
                  </button>
                }
              }
            </mat-menu>
          }
        </ng-container>
      }
    }
  </ul>
</nav>

<!-- Mobile navigation panel -->
<nav class="mobile-nav" id="main-nav" [attr.aria-label]="'navigation.aria.mobile_navigation' | translate">
  <!-- User header -->
  <div class="mobile-nav__user-header">
    <div class="mobile-nav__avatar" aria-hidden="true">
      {{ getUserInitials() }}
    </div>
    <div class="mobile-nav__user-info">
      <span class="mobile-nav__user-name">{{ getUserFullName() }}</span>
      <span class="mobile-nav__user-email">{{ getUserEmail() }}</span>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Navigation links -->
  <div class="mobile-nav__links">
    @for (route of getRoutes(); track $index) {
      @if (isMenuItemDisplayed(route) && route.data?.title) {
        <!-- Route sans enfants → lien direct -->
        @if (!route.children || route.children.length === 0) {
          <a
            class="mobile-nav__link"
            [routerLink]="route.path"
            routerLinkActive="mobile-nav__link--active"
            (click)="close()"
          >
            @if (route.data?.icon) {
              <span class="mobile-nav__icon-wrapper" aria-hidden="true">
                <mat-icon [svgIcon]="'total-' + route.data?.icon" aria-hidden="true"></mat-icon>
              </span>
            }
            <span class="mobile-nav__link-label">{{ route.data?.title | translate }}</span>
          </a>
        }

        <!-- Route avec enfants → accordéon -->
        @if (route.children && route.children.length > 0) {
          <button
            class="mobile-nav__link mobile-nav__link--parent"
            (click)="toggleExpand(route.path!)"
            [attr.aria-expanded]="isExpanded(route.path!)"
          >
            @if (route.data?.icon) {
              <span class="mobile-nav__icon-wrapper" aria-hidden="true">
                <mat-icon [svgIcon]="'total-' + route.data?.icon" aria-hidden="true"></mat-icon>
              </span>
            }
            <span class="mobile-nav__link-label">{{ route.data?.title | translate }}</span>
            <mat-icon class="mobile-nav__chevron" aria-hidden="true">expand_more</mat-icon>
          </button>

          @if (isExpanded(route.path!)) {
            @for (child of route.children; track $index) {
              @if (isMenuItemDisplayed(child) && child.data?.title) {
                <a
                  class="mobile-nav__link mobile-nav__link--child"
                  [routerLink]="route.path + '/' + child.path"
                  routerLinkActive="mobile-nav__link--active"
                  (click)="close()"
                >
                  <span class="mobile-nav__link-label">{{ child.data?.title | translate }}</span>
                </a>
              }
            }
          }
        }
      }
    }
  </div>

  <mat-divider></mat-divider>

  <!-- Footer: language + logout -->
  <div class="mobile-nav__footer">
    <div class="mobile-nav__lang-section">
      <span class="mobile-nav__lang-label">{{ 'navigation.mobile.language' | translate }}</span>
      <div
        class="mobile-nav__lang-selector"
        role="radiogroup"
        [attr.aria-label]="'navigation.aria.language_selector' | translate"
      >
        @for (lang of languages; track lang) {
          <button
            class="mobile-nav__lang-btn"
            [class.mobile-nav__lang-btn--active]="currentLang === lang"
            role="radio"
            [attr.aria-checked]="currentLang === lang"
            (click)="switchLanguage(lang)"
          >
            {{ getLangLabel(lang) }}
          </button>
        }
      </div>
    </div>

    <a
      class="mobile-nav__logout"
      [routerLink]="logoutRoute"
      [attr.aria-label]="'navigation.aria.logout' | translate"
      (click)="close()"
    >
      <mat-icon aria-hidden="true">logout</mat-icon>
      <span>{{ 'navigation.mobile.logout' | translate }}</span>
    </a>
  </div>
</nav>
